type Props = {
  vendor: string;
  size: 'tiny' | 'small' | 'medium' | 'large';
  customSrc?: string;
};

const SIZE = {
  tiny: { box: 'h-5 w-5', img: 'h-4 w-4' },
  small: { box: 'h-7 w-7', img: 'h-6 w-6' },
  medium: { box: 'h-8 w-8', img: 'h-7 w-7' },
  large: { box: 'h-10 w-10', img: 'h-9 w-9' },
} as const;

export const VendorLogoBlock = ({ vendor, size, customSrc }: Props) => {
  return (
    <div className={`flex shrink-0 items-center justify-center rounded bg-white ${SIZE[size].box}`}>
      <img
        src={customSrc || `${process.env.REACT_APP_IMG_URL}/images/favis/32/${vendor}.png`}
        alt='vendor-logo'
        loading='lazy'
        className={`rounded-sm ${SIZE[size].img}`}
      />
    </div>
  );
};
